import React from "react";
import { graphql } from "gatsby";
import ObjectLayout from "./../components/ObjectLayout";
import ObjectHeader from "./../components/ObjectHeader";
import ObjectConnections from "./../components/ObjectConnections";
import { ObjectBody } from "./../components/ObjectLayout/elements";
import TimelineEntryBlock from "./../components/TimelineEntryBlock";

const eventTypeName = {
  worldHistory: "world history",
  biography: "biographical",
  techHistory: "tech history",
};

const TimelineEventPage = ({ data, pageContext }) => {
  const {
    title,
    eventType,
    description,
    date,
    dateApproximateness,
    endDate,
    endDateApproximateness,
    people,
    keywords,
  } = data.sanityTimelineEntry;
  // console.log(data, pageContext.id);
  return (
    <ObjectLayout title={`Timeline event: ${title}`}>
      <ObjectHeader
        title={title}
        subtitle={eventTypeName[eventType] || eventType}
        date={date}
        endDate={endDate}
        dateApproximateness={dateApproximateness}
        endDateApproximateness={endDateApproximateness}
      />

      {description ? (
        <ObjectBody>
          <TimelineEntryBlock description={description} />
        </ObjectBody>
      ) : null}
      {people.length || keywords.length ? (
        <ObjectConnections people={people} keywords={keywords} />
      ) : null}
    </ObjectLayout>
  );
};

export default TimelineEventPage;

export const pageQuery = graphql`
  query($id: String!) {
    sanityTimelineEntry(_id: { eq: $id }) {
      title
      description
      date: startDate
      dateApproximateness
      endDate
      endDateApproximateness
      eventType
      people {
        _id
        title
      }
      keywords {
        _id
        title
      }
    }
  }
`;
